import React from "react";

// Resmi WhatsApp glifi
export const WhatsAppGlyph = ({ className = "w-6 h-6" }) => (
  <svg viewBox="0 0 32 32" className={className} aria-hidden fill="currentColor">
    <path d="M16.004 2.667c-7.36 0-13.33 5.97-13.33 13.33 0 2.35.616 4.646 1.787 6.67L2.667 29.33l6.83-1.79a13.27 13.27 0 0 0 6.507 1.657h.005c7.36 0 13.33-5.97 13.33-13.33 0-3.562-1.387-6.91-3.906-9.43a13.24 13.24 0 0 0-9.43-3.9zm0 24.44h-.004a11.06 11.06 0 0 1-5.64-1.545l-.404-.24-4.053 1.063 1.082-3.95-.264-.42a11.05 11.05 0 0 1-1.695-5.89c0-6.12 4.98-11.1 11.104-11.1 2.966 0 5.752 1.155 7.848 3.253a11.03 11.03 0 0 1 3.25 7.85c0 6.122-4.98 11.1-11.104 11.1zm6.09-8.315c-.334-.167-1.975-.975-2.28-1.086-.306-.111-.529-.167-.752.167-.222.333-.863 1.086-1.058 1.309-.195.222-.39.25-.723.083-.334-.167-1.41-.52-2.686-1.657-.993-.885-1.664-1.98-1.859-2.314-.195-.333-.021-.513.146-.679.15-.149.334-.39.5-.585.168-.195.223-.334.335-.556.111-.223.056-.417-.028-.585-.083-.167-.752-1.812-1.03-2.48-.271-.651-.547-.563-.752-.573l-.64-.011c-.223 0-.585.083-.891.417-.306.333-1.169 1.142-1.169 2.786s1.197 3.23 1.364 3.453c.167.222 2.357 3.6 5.71 5.048.798.345 1.42.55 1.905.704.8.254 1.528.218 2.104.132.642-.096 1.975-.807 2.253-1.587.278-.78.278-1.448.195-1.587-.083-.139-.306-.222-.64-.389z"/>
  </svg>
);

// REMINDER: iletişim numarası tek yerden yönetilir
const WA_NUMBER = "905322705174";
const WA_TEXT = encodeURIComponent("Merhaba, 365Rez hakkında bilgi almak istiyorum.");

export default function WhatsAppButton() {
  return (
    <a
      href={`https://wa.me/${WA_NUMBER}?text=${WA_TEXT}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp ile iletişime geç"
      data-testid="whatsapp-float-btn"
      className="fixed bottom-5 right-5 z-50 flex items-center gap-2 rounded-full bg-[#25D366] text-white pl-3 pr-4 py-3 shadow-lg shadow-black/20 transition-transform duration-200 hover:scale-105 active:scale-95"
    >
      <span className="absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-40 animate-ping" aria-hidden />
      <WhatsAppGlyph className="w-6 h-6 relative" />
      <span className="relative text-sm font-semibold hidden sm:block">WhatsApp</span>
    </a>
  );
}
